/**
 * @see https://www.gatsbyjs.org/docs/browser-apis/
 */

exports.onClientEntry = () => {
  try {
    const t = window.localStorage.getItem('theme')
    if (t === 'light' || t === 'dark') {
      document.documentElement.setAttribute('data-theme', t)
    }
  } catch (e) {
    /* ignore */
  }
}
